export default __webpack_public_path__ + "static/media/star.856a0c6a.svg";